// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';

function switchTagAllCheckbox() {
  // 全てのチェックを外す
  $('input[name="tag_id[all]"]').prop('checked', false);
  // 全て手動でチェックされた場合、チェックボックスの「全て」にチェックをつける
  if ($('input[name="q[tags_id_in][]"]:checked').length === $('input[name="q[tags_id_in][]"]').length - 1) {
    $('input[name="tag_id[all]"]').prop('checked', true);
  }

  if ($('input[name="parent_tag[]"]').length) {
    if ($('input[name="parent_tag[]"]:checked').length === $('input[name="parent_tag[]"]').length) {
      $('input[name="tag_id[all]"]').prop('checked', true);
    }
  }
}

$(() => {
  if ($('#tag_id_all')) {
    // イベント、ニュースのカテゴリー全て選択時、カテゴリーの状態も変更する
    // 来年度制作分の特集、モデルコースもここに含まれる予定
    $('input[name="tag_id[all]"]').click((e) => {
      $('input[name="q[tags_id_in][]"]').prop('checked', e.target.checked);
      $('input[name="parent_tag[]"').prop('checked', e.target.checked);
    });

    // カテゴリー選択の場合、全ての選択状態を設定/解除を行う
    $('input[name="q[tags_id_in][]"]').click(() => {
      switchTagAllCheckbox();
    });

    // イベントの場合、カテゴリー大分類が画面に表示されているが、イベントとカテゴリー（大分類）は紐付けを行なっていない為、
    // カテゴリー（小分類）をdisplay: noneにて非表示にしている。表示しているカテゴリー（大分類）をクリックした際に、紐づくカテゴリー（小分類）
    // をchecked: trueに設定することでカテゴリー（大分類）を検索しているようにしている。検索に利用しているのはあくまでカテゴリー（小分類）
    if ($('input[name="parent_tag[]"]').length) {
      $('input[name="parent_tag[]"]').on('click', (e) => {
        $(`.tag_${e.target.value}`).prop('checked', e.target.checked);
        switchTagAllCheckbox();
      });
    }
  }
});
